// LIBRERIE
import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

//IMG
import marzocchiImg from "../../../public/assets/images/inHome/agenzia1.jpg";


const Presentation: React.FC = () => {
    const { t } = useTranslation();

    // Titolo animazione
    const [titleVisible, setTitleVisible] = useState(false);
    const presentationTitle = useRef<HTMLHeadingElement | null>(null);
    

    useEffect(() => {
        const handleScroll = () => {
            // Calcola la posizione dell'elemento
            const coordinates = presentationTitle.current?.getBoundingClientRect();
            // Calcola posizione nella viewport
            const positionInDOM = coordinates ? coordinates.bottom + window.scrollY +10 : 0
            // Calcola il punto più basso della viewport
            const clientViewHeight = window.scrollY + window.innerHeight;
            if( positionInDOM < clientViewHeight){
                setTitleVisible(true);
            };
        }

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        }
    }, [])

    return(
        <section id="presentation" className="space-ptb">
            <div className="container">
                <div className="row justify-content-center align-items-center">
                    <div className="col-12 col-lg-8 mb-4 mb-lg-0">
                        <h1 className={`mb-4 ${titleVisible ? "visible" : ""}`} ref={presentationTitle}>{t('homePage.presentation.title')}</h1>
                        <p className="lead">{t('homePage.presentation.subTitle')}</p>
                        <p className="mb-4" dangerouslySetInnerHTML={{ __html: t('homePage.presentation.text1') as string }}></p>
                        <Link to={'/chi-siamo'} className="btn btn-primary text-uppercase">
                            {t('homePage.presentation.btnText')}
                        </Link>
                    </div>
                    <div className="col-12 col-lg-4">
                        <img src={marzocchiImg} className="img-fluid" alt="Marzocchi" style={{border:'1px solid #000'}} />
                    </div>
                </div>
            </div>
            <img src={''} className="d-none d-xl-block" alt="Alessandro Salvadori"/>
        </section>
    )
}
export default Presentation;